import { render, staticRenderFns } from "./create-skill.component.html?vue&type=template&id=643a0f71&scoped=true&"
import script from "./create-skill.component.ts?vue&type=script&lang=ts&"
export * from "./create-skill.component.ts?vue&type=script&lang=ts&"
import style0 from "./create-skill.component.scss?vue&type=style&index=0&id=643a0f71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643a0f71",
  null
  
)

export default component.exports